import { __spreadArray as r$1 } from '../external_external_node_modules/tslib/tslib.es6.js';
import { languageResolver as r } from '../utils/languageResolver.js';

var s=function(){function s(t,e){this.setLanguage(t),this.setSettings(e);}return s.prototype.setLanguage=function(t){this.language=r(t);},s.prototype.setSettings=function(t){void 0===t&&(t={});this.settings=Object.assign({},{rules:[]},t);},s.prototype.joinRulesWithDefault=function(e){var s=this.settings.rules||[];return r$1(r$1([],s),e)},s}();

export { s as BaseFormatter };
//# sourceMappingURL=base.js.map
